export const backendUrl = process.env.VUE_APP_BACKEND_URL;
export const frontendUrl = process.env.VUE_APP_FRONTEND_URL;
